export default __webpack_public_path__ + "static/media/visa-icon.75945e67.svg";